<div class="ro-activity flex-start-start width-100p mb-3 position-relative">
  <div class="activity-icon-wrapper flex-center-center">
    <div class="activity-icon flex-center-center" [ngClass]="{ 'core-activity': activity?.isPrimary }">
      <i [ngClass]="activity?.data?.icon ? activity?.data?.icon : 'fas fa-file-alt'"></i>
    </div>
  </div>
  <!-- {{activity?.data | json}} -->

  <div class="activity-overview flex-column">
    <p class="m-0 font-bold">{{activity?.title}}</p>
    <p class="m-0 font-gray-35 font-13">
      by {{activity?.actionBy}} at {{activity?.createdAt | date: 'MMM dd, yyyy hh:mma'}}
    </p>
  </div>

  <div class="activity-details">
    <!-- Order created -->
    <p *ngIf="activity?.entityType === 'order'">
      <!-- Order title Updated -->
      <span *ngIf="activity?.entityAction === 'updated' && activity?.data?.type === 'title'">
        <span class="font-bold">
          RO# {{code}}: {{activity?.data?.oldTitle}}
        </span>
        RO's title was updated to
        <span class="font-bold">{{activity?.data?.title}}</span>
      </span>

      <!-- Order Misc Activity -->
      <span
        *ngIf="(activity?.entityAction === 'updated' || activity?.entityAction === 'created') && activity?.data?.type === 'plaintext'">
        <span [innerHTML]="activity?.text"></span>
      </span>
    </p>

    <!-- Deposit request -->
    <p *ngIf="activity?.entityType === 'depositRequest'">
      <span [innerHTML]="activity?.text"></span>
    </p>
    <!-- Deposit request ended -->

    <!-- refund activity -->
    <p *ngIf="activity?.entityType === 'refund'">
      <!-- Text -->
      <span [innerHTML]="activity?.text"></span>
    </p>
    <!-- refund activity ended -->

    <!-- Canned service added -->
    <p *ngIf="activity?.entityType === 'manualOrder' && activity?.entityAction === 'updated'">
      <span [innerHTML]="activity?.text"></span>
    </p>

    <!-- Order Customer -->
    <p *ngIf="activity?.entityType === 'customer'">
      <span *ngIf="activity?.entityAction === 'added'">
        <span class="pointer clickable" (click)="handleOpenCustomerInSidepanel(activity?.entityTypeId)">
          RO# {{code}} - Customer: {{activity?.data?.fullName}}
        </span> was added to RO
      </span>

      <span *ngIf="activity?.entityAction === 'updated'">
        RO# {{code}}: Customer was updated from
        <span class="pointer clickable" (click)="handleOpenCustomerInSidepanel(activity?.data?.oldCustomerId)">
          {{activity?.data?.oldFullName}}
        </span> to
        <span class="pointer clickable" (click)="handleOpenCustomerInSidepanel(activity?.entityTypeId)">
          {{activity?.data?.fullName}}
        </span>
      </span>
    </p>

    <!-- Order Vehicle -->
    <p *ngIf="activity?.entityType === 'vehicle'">
      <span *ngIf="activity?.entityAction === 'merged'">
        <span class="pointer clickable"> {{activity?.text}}</span>
      </span>

      <span *ngIf="activity?.entityAction === 'added'">
        <span class="pointer clickable"
          (click)="handleOpenVehicleInSidepanel(activity?.data?.customerId, activity?.entityTypeId)">
          RO# {{code}} - Vehicle: {{activity?.data?.name}}
        </span> was added to RO
      </span>

      <span *ngIf="activity?.entityAction === 'removed'">
        <span class="pointer clickable"
          (click)="handleOpenVehicleInSidepanel(activity?.data?.customerId, activity?.entityTypeId)">
          RO# {{code}} - Vehicle: {{activity?.data?.name}}
        </span> was removed from RO
      </span>

      <span *ngIf="activity?.entityAction === 'updated'">
        Vehicle was updated from <span class="pointer clickable"
          (click)="handleOpenVehicleInSidepanel(activity?.data?.oldCustomerId, activity?.data?.oldVehicleId)">
          {{activity?.data?.oldName}}
        </span> to
        <span class="pointer clickable"
          (click)="handleOpenVehicleInSidepanel(activity?.data?.customerId, activity?.entityTypeId)">
          {{activity?.data?.name}}
        </span>
      </span>
    </p>

    <!-- Canned service added -->
    <p *ngIf="activity?.entityType === 'service' && activity?.entityAction === 'added'">
      RO# {{code}} - {{activity?.data?.title === 'Untitled' ? 'Service ' : 'Canned service'}}: {{activity?.data?.title}} for amount
      {{activity?.data?.total || 0 | currency: usd}} was added
    </p>

    <!-- Canned service removed -->
    <p *ngIf="activity?.entityType === 'service' && activity?.entityAction === 'deleted'">
      RO# {{code}} - {{activity?.data?.title === 'Untitled' ? 'Service ' : 'Canned service'}}: {{activity?.data?.title}} for amount {{activity?.data?.total || 0 | currency: usd}}
      was deleted
    </p>

    <!-- Inspection Report send -->
    <p *ngIf="activity?.entityType === 'inspection'">
      {{activity.text}}
    </p>

    <!-- Order Misc Activity -->
    <span
      *ngIf="activity?.entityType === 'service' && activity?.entityAction === 'updated' && activity?.data?.type === 'plaintext'">
      <span [innerHTML]="activity?.text"></span>
    </span>

    <span
      *ngIf="activity?.entityType === 'service' && activity?.data?.type === 'plaintext' && activity?.entityAction === 'create' ">
      {{activity?.text}}
    </span>

    <!-- Statement Logs -->
    <!-- Order Misc Activity -->
    <span *ngIf="activity?.entityType === 'statement'">
      <span [innerHTML]="activity?.text"></span>
    </span>

    <!-- Tech Assigned -->
    <p
      *ngIf="activity?.entityType === 'service' && activity?.entityAction === 'updated' && activity?.data?.type === 'assign'">
      Service - {{activity?.data?.title}}: Technician {{activity?.data?.techName}} was assigned to this Service
    </p>

    <!-- Service status update -->
    <p
      *ngIf="activity?.entityType === 'service' && activity?.entityAction === 'updated' && activity?.data?.type === 'serviceStatusUpdated'">
      RO# {{code}}: Service status of {{activity?.data?.title}} was updated from
      {{workStateTitle[activity?.data?.oldStatus]}} to {{workStateTitle[activity?.data?.status] }}
      {{activity?.data?.techName ? ' by '+ activity?.data?.techName : ''}}
    </p>

    <!-- Service authorisation status update -->
    <p *ngIf="activity?.entityType === 'service' && activity?.entityAction === 'authStatus'">
      {{activity?.text}}
    </p>

    <!-- Order authorisation -->
    <p *ngIf="activity?.entityType === 'authorization' && activity?.entityAction === 'authStatus'">
      {{activity?.text}}
    </p>

    <!-- Reviews -->
    <div *ngIf="activity?.entityType === 'reviews' && activity?.entityAction === 'updated'">
      <p class="m-0" *ngIf="activity?.data?.type === 'review-request'">
        RO# {{code}}: Review request & receipt for {{activity?.data?.total | currency: usd}} via
        <span *ngIf="activity?.data?.phone">{{activity?.data?.phone}}</span>
        <span *ngIf="activity?.data?.phone && activity?.data?.email"> and </span>
        <span *ngIf="activity?.data?.email">{{activity?.data?.email}}</span>
      </p>

      <p class="m-0" *ngIf="activity?.data?.type === 'receipt'">
        RO# {{code}}: Receipt for {{activity?.data?.total | currency: usd}} was sent to customer
        {{activity?.data?.fullName}} via
        <span *ngIf="activity?.data?.phone">{{activity?.data?.phone}}</span>
        <span *ngIf="activity?.data?.phone && activity?.data?.email"> and </span>
        <span *ngIf="activity?.data?.email">{{activity?.data?.email}}</span>
      </p>

      <p class="m-0" *ngIf="activity?.data?.type === 'receipt-review'">
        RO# {{code}}: Receipt for {{activity?.data?.total}} was sent to customer {{activity?.data?.fullName}} via
        <span *ngIf="activity?.data?.phone">{{activity?.data?.phone}}</span>
        <span *ngIf="activity?.data?.phone && activity?.data?.email"> and </span>
        <span *ngIf="activity?.data?.email">{{activity?.data?.email}}</span>
      </p>
    </div>

    <!-- Appointments -->
    <p *ngIf="activity?.entityType === 'appointment' && activity?.entityAction === 'created'">
      <span *ngIf="!activity?.data?.isVehiclePickUp">
        RO# {{code}} - Appointment: <span class="clickable pointer"
          (click)="handleOpenAppointment(activity?.entityTypeId)">{{activity?.data?.title}}</span> was scheduled for
        {{activity?.data?.date}}
      </span>

      <span *ngIf="activity?.data?.isVehiclePickUp">
        RO# {{code}}: Vehicle pickup for <span class="clickable pointer"
          (click)="handleOpenAppointment(activity?.entityTypeId)">{{activity?.data?.name}}</span> was scheduled for
        {{activity?.data?.date}}
      </span>
    </p>

    <!-- Service status update -->
    <p *ngIf="activity?.entityType === 'status' && activity?.entityAction === 'updated'">
      <span class="capitalize"></span>

      <span *ngIf="activity?.data?.orderStatus === 'invoice'">
        Invoice# {{invCode? invCode : code}}
        for <span class="">{{activity?.data?.total | currency: usd}}</span> was generated against RO# {{code}}
      </span>

      <span *ngIf="activity?.data?.orderStatus === 'estimate'">
        RO# {{code}}:
        Invoice for <span class="">{{activity?.data?.total | currency: usd}}</span> was reverted to Estimate
      </span>
    </p>

    <!-- Payment Added-->
    <p *ngIf="activity?.entityType === 'payment'">
      <span *ngIf="activity?.data?.type === 'plaintext'">
        {{activity?.text}}
      </span>

      <ng-container *ngIf="activity?.data?.type !== 'plaintext'">
        <span *ngIf="activity?.data?.type === 'paymentCreated' && activity?.entityAction === 'added'">
          RO# {{code}}: New payment ({{activity?.data?.paymentMethod}} {{activity?.data?.total | currency: usd}} ) was
          added to Invoice
        </span>

        <!-- If payment created via payLink-->
        <span *ngIf="activity?.data?.type === 'paymentCreatedViaPayLink' && activity?.entityAction === 'added'">
          RO# {{code}}: New payment card - online ({{activity?.data?.total | currency: usd}} ) was
          made by the customer using 'Pay Now'
        </span>

        <span *ngIf="activity?.data?.type === 'paymentUpdated' && activity?.entityAction === 'updated'">
          RO# {{code}}: Payment {{activity?.data?.oldTotal | currency: usd}} ({{activity?.data?.oldPaymentMethod}}) was
          updated to {{activity?.data?.total | currency: usd}} ({{activity?.data?.paymentMethod}})
        </span>

        <span *ngIf="activity?.entityAction === 'partialApprovedPayment'">
          <span class="pointer clickable open-link-container">
            <app-open-tab-link link="/estimate/{{ orderId }}" [tabId]="orderId" [title]="estCode"
              [showForHistory]="true" [titleClass]="font-color"></app-open-tab-link>
          </span> {{activity.text}}
        </span>

        <span *ngIf="activity?.data?.type === 'paymentError'">
          RO# {{code}}: {{activity.text}}
        </span>

       <p *ngIf="activity?.entityAction === 'terminalTransaction'">
        <span>
          RO# {{code}}: {{activity.text}}
        </span>
        <span *ngIf="activity?.data?.payloadToSend?.reference_id && !activity?.data?.globalPayResponse?.status">
          &nbsp;-&nbsp;
          <span *ngIf="!isTransactionLookupActive" class="font-primary hover-underline"
            (click)="lookupTransaction(activity?.data)">Find Transaction in GP</span>
          <i *ngIf="isTransactionLookupActive" class="fal fa-spinner rotate"></i>
        </span>
       </p> 

        <span *ngIf="activity?.entityAction === 'cardOnlineTransaction'">
          RO# {{code}}: {{activity.text}}
        </span>
        <span *ngIf="activity?.data?.type === 'paymentPaidStatus' && activity?.entityAction === 'updated'">
          <span>
            {{getPaymentActivityText(code,activity?.data)}}
          </span>
        </span>
      </ng-container>
    </p>

    <!-- Quickbooks -->
    <p *ngIf="activity?.entityType === 'quickbook'">
      <!-- Added -->
      <span *ngIf="activity?.entityAction === 'added'">
        RO# {{code}}: Invoice for amount {{activity?.data?.total | currency: usd}} was posted to QBO
      </span>

      <!-- Updated -->
      <span *ngIf="activity?.entityAction === 'updated'">
        RO# {{code}}: Invoice posted to QBO was updated from {{activity?.data?.oldTotal | currency: usd}} to
        {{activity?.data?.total | currency: usd}}
      </span>
    </p>

    <!-- Order Authorization -->
    <p *ngIf="activity?.entityType === 'authorization'">
      <!-- Added -->
      <span *ngIf="activity?.entityAction === 'approved' || activity?.entityAction === 'notApproved'">
        RO# {{code}}: Estimate for {{activity?.data?.total | currency: usd}}
        <span *ngIf="activity?.data?.isApprovedByCustomer">was approved by customer</span>
        <span *ngIf="!activity?.data?.isApprovedByCustomer">was manually
          {{activity?.entityAction === 'approved'? 'approved': 'unapproved'}}</span>
      </span>
      <span *ngIf="activity?.entityType === 'authStatus'">&nbsp;-&nbsp;</span>
      <span *ngIf="activity?.entityAction === 'sent'" [innerHTML]="activity?.text"></span>
      <span *ngIf="activity?.data?.hasPdf">
        &nbsp;-&nbsp;
        <span *ngIf="!isFetchingPdf" class="font-primary hover-underline"
          (click)="downloadSignedUrl(activity?.data?.docId, activity?.data?.docKey)">PDF</span>
        <i *ngIf="isFetchingPdf" class="fal fa-spinner rotate"></i>
      </span>
    </p>

    <!-- Order Authorization -->
    <p *ngIf="activity?.entityType === 'invoice'">
      <span *ngIf="activity?.entityAction === 'sent'" [innerHTML]="activity?.text"></span>
      <span *ngIf="activity?.data?.hasPdf">
        &nbsp;-&nbsp;
        <span *ngIf="!isFetchingPdf" class="font-primary hover-underline"
          (click)="downloadSignedUrl(activity?.data?.docId, activity?.data?.docKey)">PDF</span>
        <i *ngIf="isFetchingPdf" class="fal fa-spinner rotate"></i>
      </span>
    </p>

    <!-- Order Workflow -->
    <p *ngIf="activity?.entityType === 'workflow'">
      <!-- Added -->
      <span>
        RO#{{code}}:
        Workflow Status was updated from {{activity?.data?.oldWorkflow}} to {{activity?.data?.newWorkflow}}
      </span>
    </p>

    <!-- Attachment Workflow -->
    <p *ngIf="activity?.entityType === 'attachment'">
      <!-- Added -->
      <span>{{activity?.text}}</span>
      <span (click)="handleNewAttachmentClick(activity)" class="clickable pointer"
        *ngIf="activity?.entityAction === 'created'">&nbsp;Link</span>
    </p>
  </div>
</div>